import { render, staticRenderFns } from "./WarehouseOrder.vue?vue&type=template&id=47f86f96&scoped=true"
import script from "./WarehouseOrder.vue?vue&type=script&lang=ts"
export * from "./WarehouseOrder.vue?vue&type=script&lang=ts"
import style0 from "./WarehouseOrder.vue?vue&type=style&index=0&id=47f86f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f86f96",
  null
  
)

export default component.exports